import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAlertTriangleGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M7.843 7.7C9.207 5.337 9.89 4.156 10.78 3.76a3 3 0 0 1 2.44 0c.89.396 1.573 1.577 2.937 3.94l2.944 5.1c1.365 2.363 2.047 3.544 1.945 4.514a3 3 0 0 1-1.22 2.113c-.79.573-2.153.573-4.882.573H9.057c-2.729 0-4.093 0-4.882-.573a3 3 0 0 1-1.22-2.113c-.102-.97.58-2.151 1.945-4.514z'
      opacity={0.2}
    />
    <path
      fill={props.color}
      d='M12 8c-.712 0-1.277.601-1.232 1.312l.234 3.75a1 1 0 0 0 1.996 0l.235-3.75A1.235 1.235 0 0 0 12 8M12 14.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M13.627 2.596a4 4 0 0 0-3.254 0c-.697.31-1.219.887-1.7 1.57-.48.677-1.01 1.596-1.67 2.74l-2.996 5.189c-.66 1.143-1.19 2.062-1.538 2.816-.35.758-.589 1.498-.51 2.257a4 4 0 0 0 1.628 2.818c.617.448 1.377.612 2.21.688.826.076 1.887.076 3.207.076h5.992c1.32 0 2.381 0 3.208-.076.832-.076 1.592-.24 2.21-.688a4 4 0 0 0 1.626-2.818c.08-.759-.159-1.499-.509-2.257-.347-.754-.878-1.673-1.538-2.816l-2.996-5.19c-.66-1.143-1.19-2.062-1.67-2.74-.481-.682-1.003-1.259-1.7-1.57m-2.44 1.827a2 2 0 0 1 1.627 0c.193.086.458.298.88.896.42.594.905 1.433 1.597 2.631l2.944 5.1c.692 1.198 1.176 2.038 1.48 2.698.307.665.358 1 .336 1.211a2 2 0 0 1-.813 1.409c-.172.125-.488.248-1.217.315-.724.066-1.693.067-3.077.067H9.057c-1.384 0-2.353-.001-3.077-.067-.73-.067-1.045-.19-1.217-.315a2 2 0 0 1-.813-1.409c-.022-.21.029-.546.336-1.21.304-.661.788-1.5 1.48-2.699l2.944-5.1c.692-1.198 1.177-2.037 1.597-2.63.422-.599.687-.81.88-.897'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAlertTriangleGhost)
export default ForwardRef
